import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine, VerticalLine } from '../../../components/shapes/Line'
import { SmallText } from '../../../components/presentation/Text'
import ControlledModal from '../../../components/modals/ControlledModal'
import EventsList from './events/EventsList'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import ModalHeader from './ModalHeader'
import NonComplianceLoader from './_load/NonComplianceLoader'
import Separator from '../../../components/helpers/Separator'
import SideBar from './SideBar'

const NonComplianceModal = props => {
  return (
    <ControlledModal width="72rem" {...props}>
      <NonComplianceLoader>
        <ModalHeader />
        <Separator weight={6} />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={6} />

        <FlexGrid justify="space-between" align="flex-start" paddingGutter={0.5} wrap>
          <FlexCol flex={6} wrapOn="sm">
            <EventsList />
          </FlexCol>

          <FlexCol alignSelf="stretch" hideOn="sm">
            <VerticalLine thin lineColor={COLORS.light2} fullHeight />
          </FlexCol>

          <FlexCol alignSelf="stretch" hideOn="mdu" wrapOn="sm">
            <HorizontalLine thin lineColor={COLORS.light2} />
          </FlexCol>

          <FlexCol flex={2}>
            <SmallText bold>Dados gerais</SmallText>
            <Separator weight={4} />

            <SideBar />
          </FlexCol>
        </FlexGrid>
      </NonComplianceLoader>
    </ControlledModal>
  )
}

export default NonComplianceModal
